export default __webpack_public_path__ + "static/testimonialHolder6-057ef0ef176b4144549eadcceb59373b.png";